<template>
  <div class="category">
    <swiper :options="swiperOption">
      <swiper-slide
        v-for="category in categories"
        :key="category.id"
        :data-id="category.id"
        :style="{ background: transformColor[category.color.toLowerCase()] ? transformColor[category.color.toLowerCase()] : category.color}"
        :class="{ active: category.id === currentCategory }"
        class="category-slide"
        @click.native="$emit('select', category.id)"
      >
        <lazy-image
          v-if="category.image"
          :src="category.image"
          :alt="category.name"
          class="img-responsive"
        />
        <div
          v-if="category.image"
          class="category-overlay"
        />

        <span class="category-name">
          {{ category.name }}
        </span>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import LazyImage from "@/components/Common/LazyImage.vue";

/**
 * Presentational category swiper extracted from StandardOrder.vue (Phase 4).
 *
 * Pure display + selection: the parent owns `currentCategory` and the category
 * change side effects (it runs `selectCategory` on the emitted id). `swiper` /
 * `swiper-slide` are globally registered by vue-awesome-swiper.
 */
export default {
  name: "CategorySwiper",
  components: { LazyImage },
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
    swiperOption: {
      type: Object,
      default: () => ({}),
    },
    transformColor: {
      type: Object,
      default: () => ({}),
    },
    currentCategory: {
      type: [Number, String],
      default: 0,
    },
  },
};
</script>
